import { Drawer as AntDrawer, DrawerProps } from "antd";
import { ReactNode } from "react";

interface Props extends DrawerProps {
  footer?: ReactNode;
}
const Drawer = ({ placement, classNames, ...props }: Props) => {
  const radius =
    placement === "bottom"
      ? "rounded-t-card"
      : placement === "left"
      ? "rounded-r-card"
      : "rounded-l-card";
  return (
    <AntDrawer
      height={"85vh"}
      placement={placement}
      classNames={{
        ...classNames,
        content: `${radius} ${classNames?.content || ""}`,
      }}
      {...props}
    />
  );
};

export default Drawer;
